import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { INTERNAL_ACCOUNT_ID } from '../../../contractAdmin/constants';

const AccountListItem = ({
  text,
  id,
  isTPAccount,
  selected,
  concurrentMaxSeats,
  maximumSeats,
  availableSeats = 0,
  handleSelection,
  isSelectedBox,
  sso,
  accountsRight,
  selectedUser,
}) => {
  const [internalUser, setInternalUser] = useState(false);
  useEffect(() => {
    selectedUser.forEach(element => {
      if (element.accountId === INTERNAL_ACCOUNT_ID) setInternalUser(true);
    });
  }, selectedUser);
  const handleItemSelection = event => {
    event.preventDefault();
    const selectedElementId = event.currentTarget.id;
    let clearExisting = true;
    let shiftKey = false;
    if (event.ctrlKey) {
      clearExisting = false;
    }
    if (event.shiftKey) {
      shiftKey = true;
    }
    handleSelection(selectedElementId, clearExisting, shiftKey);
  };
  let renderAvailableSeats = '';
  if (!isSelectedBox) {
    renderAvailableSeats = (
      <span>
        {concurrentMaxSeats ? 'Concurrent seats' : 'Available seats'}{' '}
        <strong>{concurrentMaxSeats || availableSeats}</strong> /{' '}
        <strong>{maximumSeats}</strong>
      </span>
    );
  }
  let renderAccountName = '';
  if (sso) {
    renderAccountName = <span>SSO Account</span>;
  }
  if (isTPAccount) {
    renderAccountName = <span>Third Party</span>;
  }
  if (
    (!isSelectedBox &&
      availableSeats < 1 &&
      !concurrentMaxSeats &&
      !internalUser) ||
    sso ||
    !accountsRight
  ) {
    return (
      <li
        id={id}
        className="disabled"
        title={
          !accountsRight && !sso && !availableSeats < 1
            ? 'Admin rights required'
            : ''
        }
      >
        <span className="menu-text">
          {text} {renderAvailableSeats} {renderAccountName}
        </span>
      </li>
    );
  }
  return (
    <li
      onMouseDown={handleItemSelection}
      id={id}
      className={selected ? 'active' : ''}
    >
      <a>
        <span className="menu-text">
          {text} {renderAvailableSeats} {renderAccountName}
        </span>
      </a>
    </li>
  );
};

AccountListItem.propTypes = {
  handleSelection: PropTypes.func,
  text: PropTypes.string,
  id: PropTypes.number,
  availableSeats: PropTypes.number,
  isTPAccount: PropTypes.bool,
  selected: PropTypes.bool,
  isSelectedBox: PropTypes.bool,
  sso: PropTypes.bool,
};

export default AccountListItem;
